// theme.ts

// ___keep this in sync with $safe-area-backdrop-color in
// src/components/app/styles/_variables.scss; this is the color shown behind
// the safe area (device notch / Telegram's fullscreen header), applied both
// as `body`'s CSS background and as Telegram's native header/background
// color (see main.tsx) so there's no visible mismatch between the two.
export const SAFE_AREA_BACKDROP_COLOR = "#353755";
